angular.module("vgresiduos").controller("ExecutiveReportSuppliersCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "bi/relatorio-executivo-fornecedores");
		};
	}
]);
